<template>
  <div class="menu-top">
    <v-toolbar height="64" :dark="darkEnabled">
      <v-app-bar-nav-icon class="hide-on-desktop" @click="changeMenuLeft">
        <v-icon size="20" :color="toolbarIconColor">fas fa-bars</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/fornecedor/inicio"
          ><img class="logo-menu" src="@/assets/logo-lifeapps.png"
        /></router-link>
      </v-toolbar-title>

      <router-link
        v-if="getFornecedores.length"
        to="/fornecedor/novidades"
        class="btn-cta-novidades"
        :class="{ 'btn-cta-novidades--active': isNovidadesRoute }"
      >
        <v-icon size="14" class="btn-cta-novidades__icon">
          fas fa-bullhorn
        </v-icon>
        <span class="btn-cta-novidades__label mx-1">
          ACESSAR NOVIDADES LIFEAPPS
        </span>
        <span class="btn-cta-novidades__status" aria-hidden="true">
          <span class="btn-cta-novidades__status-ping" />
          <span class="btn-cta-novidades__status-core" />
        </span>
        <span
          v-if="getNovidadesContador > 0"
          class="btn-cta-novidades__count"
          :aria-label="`${getNovidadesContador} novidades não lidas`"
        >
          {{ getNovidadesContador > 99 ? "99+" : getNovidadesContador }}
        </span>
      </router-link>

      <v-spacer></v-spacer>
      <v-menu bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="btn-font-size menu-right" text v-on="on">
            <v-icon size="15">fas fa-university</v-icon>
            <span v-if="!getFornecedores.length" style="padding-left: 5px;">
              Sem fornecedor
            </span>
            <span style="margin-left:5px;">{{ getFornecedorNome }}</span>
          </v-btn>
        </template>

        <v-list v-if="getFornecedores.length">
          <v-list-item
            v-for="fornecedor in getFornecedores"
            :key="fornecedor.idfornecedor"
            @click="alteraFornecedor(fornecedor.idfornecedor)"
          >
            <v-list-item-title>{{ fornecedor.nome }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-toolbar-items class="menu-right">
        <v-btn
          class="btn-font-size"
          text
          to="/fornecedor/configuracoes/usuarios/meu-usuario"
          ><v-icon size="15">far fa-user-circle</v-icon
          ><span style="margin-left:5px;">{{ getUsuarioNome }}</span></v-btn
        >
        <v-btn
          class="btn-font-size"
          text
          :aria-label="darkEnabled ? 'Usar tema claro' : 'Usar tema escuro'"
          @click="toggleDarkMode"
        >
          <v-icon size="15">{{
            darkEnabled ? "fas fa-sun" : "fas fa-moon"
          }}</v-icon>
        </v-btn>
        <v-btn class="btn-font-size" text @click="logout"
          ><v-icon size="15">fas fa-sign-out-alt</v-icon></v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  MENU_ALTERA_FORNECEDOR,
  MENU_TOGGLE,
  MENU_TOGGLE_DARK_MODE
} from "../store/actions/menu";
import { AUTH_LOGOUT } from "../store/actions/auth";
import { CLEAR_STATE } from "../store/actions/menu";

export default {
  name: "NavBarTop",
  computed: {
    ...mapGetters([
      "getFornecedores",
      "getFornecedorNome",
      "getUsuarioNome",
      "darkEnabled",
      "getNovidadesContador"
    ]),
    toolbarIconColor() {
      return this.darkEnabled
        ? "rgba(255, 255, 255, 0.87)"
        : "rgba(0, 0, 0, 0.87)";
    },
    isNovidadesRoute() {
      return (
        this.$route.path === "/fornecedor/novidades" ||
        this.$route.path.startsWith("/fornecedor/novidades/")
      );
    }
  },
  methods: {
    toggleDarkMode() {
      this.$store.dispatch(MENU_TOGGLE_DARK_MODE);
    },
    alteraFornecedor(idfornecedor) {
      this.$store.dispatch(MENU_ALTERA_FORNECEDOR, idfornecedor);
      location.reload();
    },
    async logout() {
      try {
        await this.$store.dispatch(AUTH_LOGOUT);
        this.$store.dispatch(CLEAR_STATE);
      } catch (error) {
        this.$store.dispatch(CLEAR_STATE);
      }
    },
    changeMenuLeft() {
      this.$store.dispatch(MENU_TOGGLE);
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-top {
  position: fixed;
  width: 100%;
  .logo-menu {
    max-width: 140px;
    max-height: 100%;
    width: auto;
    height: auto;
  }
  .btn-cta-novidades {
    display: none;
    position: relative;
    align-items: center;
    gap: 8px;
    margin-left: 40px;
    padding: 6px 14px;
    border-radius: 9999px;
    border: 1px solid rgba(52, 211, 153, 0.55);
    background-color: #0f4d7a;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    text-decoration: none;
    line-height: 1.2;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
    transition: background-color 0.15s ease, box-shadow 0.15s ease;

    @media (min-width: 768px) {
      display: inline-flex;
    }

    &:hover {
      background-color: #0c3e62;
      color: #fff;
    }

    &--active {
      box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.45);
    }

    &__icon {
      color: #fff !important;
      flex-shrink: 0;
    }

    &__label {
      white-space: nowrap;
    }

    &__status {
      position: relative;
      display: inline-flex;
      flex-shrink: 0;
      width: 8px;
      height: 8px;
      align-items: center;
      justify-content: center;
    }

    &__status-ping {
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background-color: #34d399;
      opacity: 0.75;
      animation: btn-cta-novidades-ping 1.5s cubic-bezier(0, 0, 0.2, 1)
        infinite;
    }

    &__status-core {
      position: relative;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #10b981;
      box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.35);
    }

    &__count {
      position: absolute;
      top: -8px;
      right: -8px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 18px;
      height: 18px;
      padding: 0 4px;
      border-radius: 9999px;
      font-size: 10px;
      font-weight: 800;
      line-height: 1;
      color: #fff;
      background-color: #e11d48;
      border: 2px solid #fff;
      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
    }
  }

  @keyframes btn-cta-novidades-ping {
    0% {
      transform: scale(1);
      opacity: 0.75;
    }
    75%,
    100% {
      transform: scale(2.5);
      opacity: 0;
    }
  }
  z-index: 800;
  .fixed-heigth {
    height: 64px !important;
  }
}
.v-toolbar__content {
  height: 64px !important;
}
@media (min-width: 768px) {
  .hide-on-desktop {
    display: none;
  }
}

@media (max-width: 768px) {
  .menu-right {
    display: none;
  }
  .btn-cta-novidades {
    display: none !important;
  }
}
</style>
